import Vue from "vue";
import Router from "vue-router";

import Home from "../views/Home.vue";
import Search from "../views/Search.vue";
import PageNotFound from "../views/404.vue";
import NotAllowed from "../views/403.vue";
import Profile from "../views/Profile/Profile.vue";
import ProfileEdit from "../views/Profile/Edit.vue";
import Pages from "../views/Pages.vue";
import Categories from "../views/Categories.vue";

import AuthRoutes from "./auth.routes";
import Package from "./package";
import Organization from "./organization";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/404",
      name: "not-found",
      component: PageNotFound,
    },
    {
      path: "/403",
      name: "not-allowed",
      component: NotAllowed,
    },
    {
      path: "/search",
      name: "search",
      component: Search,
    },
    {
      path: "/package",
      redirect: "/"
    },
    {
      path: "/profile",
      redirect: "/"
    },
    {
      path: "/profile/:username",
      name: "profile",
      props: true,
      component: Profile
    },
    {
      path: "/profile/:username/edit",
      name: "profile_edit",
      props: true,
      component: ProfileEdit,
      meta: {
        auth: true
      }
    },
    {
      path: "/dms/pages/:slug",
      name: "pages",
      props: true,
      component: Pages
    },
    {
      path: "/dms/categories/:slug",
      name: "categories",
      props: true,
      component: Categories
    },
    AuthRoutes,
    Package.PackageOrganizationRoutes,
    Package.PackageVersionOrganizationRoutes,
    Package.PackageRoutes,
    Package.PackageVersionRoutes,
    Organization.OrganizationNew,
    Organization.OrganizationRoutes,
    {
      path: "*",
      component: PageNotFound,
    },
  ],
});
